import { EChartsOption } from "echarts";
import { EmptyTable } from "../../../clients/components/EmptyState";
import { Grid, Box } from "@mui/material";
import { RopChart } from "../../../../main/components/RopChart";
import CardBox from "../../../../main/components/CardBox";
import { Disponibilidade } from "../../types";

export default function GeneratedAvailabilityCharts(props: {
  disponibilidade: Disponibilidade | undefined;
}) {
  const { disponibilidade } = props;

  const disponibilidadeDiariaUgs = disponibilidade?.disponibilidadeUGs ?? [];

  const disponibilidadeUgsOptions: EChartsOption[] =
    disponibilidadeDiariaUgs.flatMap((ug: any) => {
      const inversoresData = ug.disponibilidadeInversores.map(
        (inversor: any) => ({
          value: inversor.disponibilidade,
          name: inversor.name,
          itemStyle: {
            color: "#FAB900",
          },
        })
      );

      const yAxisData = [
        ...ug.disponibilidadeInversores.map((inversor: any) => inversor.name),
      ];
      return {
        title: {
          text: `Disponibilidade - ${ug.name}`,
          textStyle: {
            fontSize: 12,
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: (params: any) => {
            const value = params[0]?.value ?? 0;
            const name = params[0]?.name ?? "";
            return value === 0
              ? `${name} ${value}% - Sem Comunicação`
              : `${name} ${value}%`;
          },
        },
        backgroundColor: "transparent",
        legend: {
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            fontSize: 8,
          },
          data: yAxisData,
        },
        grid: {
          left: 10,
          right: 25,
          bottom: 0,
          top: 25,
          containLabel: true,
        },
        xAxis: {
          type: "value",
          min: 0,
          max: 100,
          interval: 25,
          axisLabel: {
            formatter: "{value}%",
          },
        },
        yAxis: {
          type: "category",
          data: yAxisData,
          axisLabel: {
            fontSize: 10,
          },
        },
        series: [
          {
            type: "bar",
            data: inversoresData,
            label: {
              fontSize: 8,
              show: true,
              position: "outside",
              offset: [-1, 0],
              formatter: (params: any) => {
                const value = params.value ?? 0;
                if (value === 0) {
                  return `${value}% - Sem Comunicação`;
                } else {
                  return `${value}%`;
                }
              },
            },
          },
        ],
      };
    });

  const hasData = disponibilidadeDiariaUgs.length > 0;

  return (
    <>
      {hasData ? (
        disponibilidadeUgsOptions.map(
          (options: EChartsOption, index: number) => (
            <Grid key={index} sx={{ width: "90%" }} item xs={12} sm={12} md={6}>
              <CardBox
                sx={{
                  height: "100%",
                  width: "100%",
                  minHeight: "400px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "90%",
                    width: "95%",
                  }}
                >
                  <RopChart option={options} />
                </Box>
              </CardBox>
            </Grid>
          )
        )
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <EmptyTable title="Nenhum dado encontrado!" />
        </Box>
      )}
    </>
  );
}
